import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

interface PosterVideoProps {
    videoUrl: string;
    onVideoEnd: () => void;
}

const PosterVideo: React.FC<PosterVideoProps> = ({ videoUrl, onVideoEnd }) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [videoHeight, setVideoHeight] = useState(window.innerHeight);

    const handleResize = () => {
        setVideoHeight(window.innerHeight);
    };

    const handleScroll = () => {
        if (window.scrollY > 50) {
            videoRef.current?.pause();
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll);

        const video = videoRef.current;
        if (video) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch(() => {});
            }
        }

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <Box
            sx={{
                position: "relative",
                zIndex: 1,
                height: `${videoHeight}px`,
                overflow: "hidden",
                backgroundColor: "#000",
            }}
        >
            <video
                ref={videoRef}
                src={videoUrl}
                muted
                playsInline
                controls
                autoPlay
                onEnded={onVideoEnd}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </Box>
    );
};

export default PosterVideo;
